<template>
    <b-card no-body>
        <b-modal id="create-or-update" size="md" body-class="p-0" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <tachograph-create-or-update-manual v-model="manual" :errors="errors" :editing="editing"></tachograph-create-or-update-manual>
            <template #modal-footer><v-executer :loading="loading" text="Güncelle" :disabled="manual.DrivingTime == null" :action="createOrUpdate"></v-executer></template>
        </b-modal>


        <v-table    ref="table"
                    :items-provider="provider"
                    pagination="server"
                    search
                    :fields="fields"
                    v-on:refresh="onTableResfreh"
                    v-on:component-action="onAction"
                    :initial-load="false">
                        <template #custom-html>
                            <div class="mx-1">
                                <div class="row">
                                    <div class="col-auto mb-1">
                                        <div class="d-flex px-50 py-25 bg-light-success rounded align-items-center font-weight-bolder">
                                            <span class="material-icons-outlined d-block mr-50">check_circle</span>
                                            Dosya Yüklenmiş
                                        </div>
                                    </div>
                                    <!-- <div class="col-auto mb-1">
                                        <div class="d-flex px-50 py-25 bg-light-warning rounded align-items-center font-weight-bolder">
                                            <span class="material-icons-outlined d-block mr-50" >error_outline</span>
                                            Manuel Tanımlama
                                        </div>
                                    </div> -->
                                    <div class="col-auto mb-1">
                                        <div class="d-flex px-50 py-25 bg-light-info rounded align-items-center font-weight-bolder">
                                            <span class="material-icons-outlined d-block mr-50">run_circle</span>
                                            İzinli
                                        </div>
                                    </div>
                                    <div class="col-auto mb-1">
                                        <div class="d-flex px-50 py-25 bg-light-danger rounded align-items-center font-weight-bolder">
                                            <span class="material-icons-outlined d-block mr-50">cancel</span>
                                            Personel Çalışıyor - Dosya Yüklenmemiş
                                        </div>
                                    </div>
                                    <div class="col-auto mb-1">
                                        <div class="d-flex px-50 py-25 bg-light rounded align-items-center font-weight-bolder">
                                            <span class="material-icons-outlined d-block mr-50">adjust</span>
                                            Personel Bu Tarihte Şirkette Çalışmıyor
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="month">
                                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="year">
                                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                    </select>
                                </div>
                                <!-- <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="branches" label="Name" v-model="branch" placeholder="TÜM ŞUBELER"></v-select-list>
                                </div> -->
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success btn-block" v-on:click="$refs.table.refresh()">
                                        Sorgula
                                    </button>
                                </div>
                            </div>
                        </template>
        </v-table>
    </b-card>
    
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CompanyApi from '@/api/company'
import EmployeeOperationsApi from '@/api/employee-operations' 
import moment from 'moment'
import TachographCreateOrUpdateManual from './components/TachographCreateOrUpdateManual.vue'

export default {
    components:{
        BCard,
        TachographCreateOrUpdateManual
    },
    data(){
        return{
            fields:[],
            year:null,
            years:[],
            showingYear:null,
            month:null,
            showingMonth:null,
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            daysOfMonth:[],
            branches:[],
            branch:null,
            editing:false,
            loading:false,
            errors:{},
            manual:{
                Id:null,
                DriverCardNumber:null,
                Date:null,
                DrivingTime:null,
                UnknownTime:null,
                NightWorkingTime:null,
                Distance:null,
                DriverFullName:null 
            }
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
        this.configureFields()
        this.getBranches()
    },
    methods:{
        configureDaysOfMonth(date){
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        configureFields(){
            let fields = [
                {name:'Sürücü',key:'FullName',thClass:'w-30',tdClass:'text-nowrap'},
                {name:'Dijital Ehliyet Numarası',key:'DriverCardNumber',thClass:'w-20'},
            ]
            this.daysOfMonth.forEach(d=>{
                fields.push({
                    name:moment(d,'DD.MM.YYYY').locale('tr').format('DD ddd'),
                    key:`["Items","${d}"]`,
                    tooltip:moment(d,'DD.MM.YYYY').locale('tr').format('DD MMMM YYYY dddd'),
                    thClass:'table-vertical-text',
                    tdClass:'p-0 text-center border-left',
                    component:true,
                    componentOptions:{name:"tachograph-manual/TachographManual"},
                })
            })
            this.fields = fields
        },
        provider(data){
            return EmployeeOperationsApi.Tachograph.UploadReport({
                PaginationRequest:data,
                Month:this.month,
                Year:this.year,
            })
        },
        onTableResfreh(){
            this.showingYear = this.year
            this.showingMonth = this.month
            let date = moment(this.year+'-'+this.month,'YYYY-MM')
            this.configureDaysOfMonth(date)
            this.configureFields()
        },
        clearForm(){
            this.editing = false
            this.manual.Id = null
            this.manual.EmployeeId = null
            this.manual.DriverCardNumber = null
            this.manual.Date = null
            this.manual.DrivingTime = null
            this.manual.UnkownTime = null
            this.manual.NightWorkingTime = null
            this.manual.Distance = null
            this.manual.DriverFullName = null
        },
        createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.Tachograph.CreateOrUpdateManual(this.editing, this.manual).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        onAction(row,field){
            if(!field.IsUploaded || field.IsManuelRecord){
                this.clearForm()
                if(field.Id != null) this.editing = true
                this.manual.Id = field.Id
                this.manual.Date = field.Date
                this.manual.DriverCardNumber = row.DriverCardNumber
                this.$showModal('create-or-update')
            }
        }
    }
}
</script>

<style>

</style>